// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"special-offers-block_wrapper__tUy16","placeholder":"special-offers-block_placeholder__Dxpon"};